class SizeGuide extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initAccordion();
    this.initUnitSwitchers();
    this.initScrollBar();
  }

  initAccordion() {
    const detailsList = Array.from(this.querySelectorAll("details"));
    detailsList.forEach((details) => {
      details.addEventListener("toggle", () => {
        this.initScrollBar();
        if (!details.open) return;
        detailsList.forEach((other) => {
          if (other !== details && other.open) {
            other.removeAttribute("open");
          }
        });
      });
    });
  }

  initUnitSwitchers() {
    const panels = this.querySelectorAll("[data-size-guide-panel]");

    panels.forEach((panel) => {
      const radioCm = panel.querySelector('.unit-switcher__input[value="cm"]');
      const radioIn = panel.querySelector('.unit-switcher__input[value="in"]');
      const table = panel.querySelector("table");
      if (!radioCm || !radioIn || !table) return;

      const cells = [...table.querySelectorAll("td")].filter((td) => this.hasConvertibleValue(td.textContent));

      cells.forEach((td) => {
        if (!td.dataset.cmOriginal) td.dataset.cmOriginal = td.textContent.trim();
      });

      const applyUnit = (unit) => {
        if (unit === "cm") {
          cells.forEach((td) => (td.textContent = td.dataset.cmOriginal));
          return;
        }

        cells.forEach((td) => {
          td.textContent = td.dataset.cmOriginal.replace(/\d+(\.\d+)?/g, (num) => (parseFloat(num) / 2.54).toFixed(2));
        });
      };

      radioCm.addEventListener("change", () => applyUnit("cm"));
      radioIn.addEventListener("change", () => applyUnit("in"));

      applyUnit(radioIn.checked ? "in" : "cm");
    });
  }

  initScrollBar() {
    const tableWrappers = this.querySelectorAll("[table-wrapper]");
    tableWrappers.forEach((wrapper) => {
      const hasScrollbar = wrapper.scrollWidth > wrapper.clientWidth;
      wrapper.classList.toggle("has-scrollbar", hasScrollbar);
    });
  }

  hasConvertibleValue = (text) => /\d+(\.\d+)?/.test(text);
}

customElements.define("size-guide", SizeGuide);
